<template>
  <div
    class="flex flex-col gap-3 py-8 shadow-xl transition-all ease-in-out duration-300 px-4 rounded-lg shadow-secondary-200 border border-stone-300 bg-white"
  >
    <div class="flex items-center gap-2 border-b mb-3 pb-2">
      <ArrowBigRightDash
        :size="22"
        :class="props.pageLang === 'ar' && 'rotate-180'"
      />
      <p class="font-semibold">
        {{ translate(props.title || '', props.pageLang) }}
        <span
          v-if="props.beta"
          class="text-md text-primary-600 p-2 rounded-xl capitalize mx-4 font-bold animate-pulse"
          >{{ translate('general.beta', props.pageLang) }}</span
        >
      </p>
    </div>
    <slot></slot>
  </div>
</template>

<script setup lang="ts">
// Import Vue Packages
import { ArrowBigRightDash } from 'lucide-vue-next'

// Import Vue Custom Components
import { translate } from 'src/utils/translation'

const props = defineProps<{
  title?: string
  pageLang?: string
  pageDir?: string
  beta?: boolean
}>()
</script>
